import ColorLib from "color";
import styled from "./styled";

export * from "./theme";
export { ColorLib as Color };
export * from "./styled";
export default styled;
